import { AspectRatio, useMediaQuery } from "@chakra-ui/react";
import Slider from "react-slick";

import { NextArrow } from "components/Slider/NextArrow";
import { PrevArrow } from "components/Slider/PrevArrow";
import { useEffect, useRef, useState } from "react";

type VideoProps = {
  id?: number;
  imagem?: string;
  link?: string;
  nome?: string;
  videoUrl: string;
};

interface SlideVideoProps {
  videos: VideoProps[];
}

export const SlideVideo = ({ videos }: SlideVideoProps) => {
  const [isMobileSize] = useMediaQuery("(max-width: 992px)");
  const sliderRef = useRef<any>(null);
  const videoRef = useRef<any>(null);
  const [paused, setPaused] = useState(false)
  const [played, setPlayed] = useState(false)

  const settings = {
    arrows: true,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    nextArrow: <NextArrow classArrow="video-right" onMouseEnter={() => {sliderRef.current.slickPause()}} onMouseLeave={() => !played && sliderRef.current.slickPlay()} />,
    prevArrow: <PrevArrow classArrow="video-left" onMouseEnter={() => sliderRef.current.slickPause()} onMouseLeave={() => !played && sliderRef.current.slickPlay()} />,
  };

  const changeSlaide = () => {
    const videoPlayer = document.getElementById('videoPlayer') as HTMLVideoElement;  
    videoPlayer.pause();
    videoRef.current.pause()
  }

  useEffect(() => {
    if(paused){
      setPaused(true)
      changeSlaide()
    }
  }, [paused])

  return (
    <div>
      <Slider ref={sliderRef} {...settings} className="slider-container-video" onSwipe={() => changeSlaide()}>
        {videos.map(({ id, videoUrl, nome, imagem, link }, index) => {
          return (
            <div key={index}>
              <div className="slider-video">
                <div className="box-bg" />
                <AspectRatio>
                  <video
                    ref={videoRef}
                    id="videoPlayer"
                    title={nome}
                    src={videoUrl}
                    autoPlay={false}
                    controls
                    poster={link}
                    onPlay={() => {setPlayed(true), sliderRef.current.slickPause()}}
                    onPause={() => {setPlayed(false), sliderRef.current.slickPlay()}}
                    onEnded={() => {setPlayed(false), sliderRef.current.slickPlay()}}
                    
                  />
                </AspectRatio>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};
